import React, { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { Download, FileText, FileSpreadsheet } from 'lucide-react';
const funnelData = [{
  name: 'Nuevos',
  value: 1000,
  color: '#4A4A4A'
}, {
  name: 'Contactados',
  value: 850,
  color: '#757575'
}, {
  name: 'Conversación',
  value: 420,
  color: '#9E9E9E'
}, {
  name: 'Micro-acuerdo',
  value: 180,
  color: '#E6E6E6'
}, {
  name: 'Propuesta',
  value: 95,
  color: '#FFFFFF'
}, {
  name: 'Cualificado',
  value: 35,
  color: '#27AE60'
}];
export function Reportes() {
  const [activeTab, setActiveTab] = useState('funnel');
  return <div className="p-4 md:p-8 max-w-[1100px] mx-auto space-y-6 pb-24 md:pb-8" data-id="element-787">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-788">
        <div data-id="element-789">
          <h1 className="text-[28px] font-bold text-growthly-text" data-id="element-790">Reportes</h1>
          <p className="text-[13px] text-growthly-muted mt-1" data-id="element-791">
            Análisis de conversión y rendimiento.
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-792">
          <button className="btn-secondary inline-flex items-center" data-id="element-793">
            <FileSpreadsheet className="w-4 h-4 mr-2" data-id="element-794" /> CSV
          </button>
          <button className="btn-secondary inline-flex items-center" data-id="element-795">
            <FileText className="w-4 h-4 mr-2" data-id="element-796" /> PDF
          </button>
        </div>
      </div>

      <div className="border-b border-white/5" data-id="element-797">
        <nav className="-mb-px flex space-x-8 overflow-x-auto hide-scrollbar" data-id="element-798">
          {['Daily Setter', 'Territory Weekly', 'QA', 'Funnel'].map(tab => {
          const id = tab.toLowerCase().replace(' ', '-');
          return <button key={id} onClick={() => setActiveTab(id)} className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-[13px] transition-colors ${activeTab === id ? 'border-growthly-green text-growthly-text' : 'border-transparent text-growthly-muted hover:text-growthly-text hover:border-white/20'}`} data-id="element-799">
                {tab}
              </button>;
        })}
        </nav>
      </div>

      {activeTab === 'funnel' && <div className="card p-6" data-id="element-800">
          <h3 className="text-[18px] font-semibold text-growthly-text mb-6" data-id="element-801">
            Funnel de Conversión Global
          </h3>

          <div className="h-[400px] w-full" data-id="element-802">
            <ResponsiveContainer width="100%" height="100%" data-id="element-803">
              <BarChart data={funnelData} layout="vertical" margin={{
            top: 20,
            right: 30,
            left: 40,
            bottom: 5
          }} data-id="element-804">
                <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} stroke="rgba(255,255,255,0.06)" data-id="element-805" />
                <XAxis type="number" hide data-id="element-806" />
                <YAxis dataKey="name" type="category" axisLine={false} tickLine={false} tick={{
              fontSize: 12,
              fill: '#BDBDBD'
            }} data-id="element-807" />
                <Tooltip cursor={{
              fill: 'rgba(255,255,255,0.05)'
            }} contentStyle={{
              backgroundColor: '#1F1F1F',
              borderRadius: '8px',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#FFFFFF'
            }} itemStyle={{
              color: '#FFFFFF'
            }} formatter={(value: number) => [`${value} leads`, 'Volumen']} data-id="element-808" />
                <Bar dataKey="value" radius={[0, 4, 4, 0]} barSize={32} label={{
              position: 'right',
              fill: '#FFFFFF',
              fontSize: 12,
              fontWeight: 600
            }} data-id="element-809">
                  {funnelData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-810" />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>

          <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4 pt-6 border-t border-white/5" data-id="element-811">
            <div data-id="element-812">
              <p className="text-[12px] text-growthly-muted" data-id="element-813">Tasa Contacto</p>
              <p className="text-[22px] font-bold text-growthly-text" data-id="element-814">85.0%</p>
            </div>
            <div data-id="element-815">
              <p className="text-[12px] text-growthly-muted" data-id="element-816">Tasa Respuesta</p>
              <p className="text-[22px] font-bold text-growthly-text" data-id="element-817">49.4%</p>
            </div>
            <div data-id="element-818">
              <p className="text-[12px] text-growthly-muted" data-id="element-819">
                Conv. a Propuesta
              </p>
              <p className="text-[22px] font-bold text-growthly-text" data-id="element-820">22.6%</p>
            </div>
            <div data-id="element-821">
              <p className="text-[12px] text-growthly-muted" data-id="element-822">
                Conv. Final (Cualificado)
              </p>
              <p className="text-[22px] font-bold text-growthly-green" data-id="element-823">3.5%</p>
            </div>
          </div>
        </div>}

      {activeTab !== 'funnel' && <div className="bg-growthly-surface/50 border border-white/10 border-dashed rounded-lg p-12 text-center" data-id="element-824">
          <p className="text-growthly-muted" data-id="element-825">
            Selecciona la pestaña Funnel para ver el gráfico principal.
          </p>
        </div>}
    </div>;
}